
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[series]",
      function () {
        return require("private-next-pages/collections/[series].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[series]"])
      });
    }
  